<!-- support-form.component.html -->
<form [formGroup]="supportForm" (ngSubmit)="onSubmit()" class="bg-white rounded-lg py-3 mb-6">
  <div class="user-group grid grid-cols-12 border-t-2 pt-4 px-6 gap-8">
    <div class="col-span-6">
        <mat-label>First Name</mat-label>

      <mat-form-field appearance="outline" class="w-full">
        <input matInput formControlName="firstName">
        <mat-error *ngIf="supportForm.get('firstName')?.hasError('required')">First name is required</mat-error>
      </mat-form-field>
    </div>

    <div class="col-span-6">
        <mat-label>Middle Name</mat-label>

      <mat-form-field appearance="outline" class="w-full">
        <input matInput formControlName="middleName">
      </mat-form-field>
    </div>

    <div class="col-span-6">

        <mat-label>Last Name</mat-label>

      <mat-form-field appearance="outline" class="w-full">
        <input matInput formControlName="lastName">
        <mat-error *ngIf="supportForm.get('lastName')?.hasError('required')">Last name is required</mat-error>
      </mat-form-field>
    </div>
    <div class="col-span-6">
        <mat-label>Client Type</mat-label>

      <mat-form-field appearance="outline" class="w-full">
        <mat-select formControlName="clientType">
          <mat-option value="Home-Based Employee">Home-Based Employee</mat-option>
          <mat-option value="Onsite">Onsite</mat-option>
        </mat-select>
        <mat-error *ngIf="supportForm.get('clientType')?.hasError('required')">Client type is required</mat-error>
      </mat-form-field>
    </div>
    <div class="col-span-6">
        <mat-label>Contact Type</mat-label>

      <mat-form-field appearance="outline" class="w-full">
        <input matInput formControlName="contactType">
        <mat-error *ngIf="supportForm.get('contactType')?.hasError('required')">Contact type is required</mat-error>
      </mat-form-field>
    </div>
    <div class="col-span-6">
        <mat-label>Company</mat-label>

      <mat-form-field appearance="outline" class="w-full">
        <input matInput formControlName="company">
        <mat-error *ngIf="supportForm.get('company')?.hasError('required')">Company is required</mat-error>
      </mat-form-field>
    </div>
    <div class="col-span-6">
        <mat-label>Organization</mat-label>

      <mat-form-field appearance="outline" class="w-full">
        <input matInput formControlName="organization">
        <mat-error *ngIf="supportForm.get('organization')?.hasError('required')">Organization is required</mat-error>
      </mat-form-field>
    </div>
    <div class="col-span-6">
        <mat-label>Department</mat-label>

      <mat-form-field appearance="outline" class="w-full">
        <input matInput formControlName="department">
        <mat-error *ngIf="supportForm.get('department')?.hasError('required')">Department is required</mat-error>
      </mat-form-field>
    </div>
    <div class="col-span-6">
        <mat-label>Support Staff</mat-label>

      <mat-form-field appearance="outline" class="w-full">
        <mat-select formControlName="supportStaff">
          <mat-option value="Yes">Yes</mat-option>
          <mat-option value="No">No</mat-option>
        </mat-select>
        <mat-error *ngIf="supportForm.get('supportStaff')?.hasError('required')">Support staff is required</mat-error>
      </mat-form-field>
    </div>
    <div class="col-span-6">
        <mat-label>Phone Number</mat-label>

      <mat-form-field appearance="outline" class="w-full">
        <input matInput formControlName="phone">
        <mat-error *ngIf="supportForm.get('phone')?.hasError('required')">Phone number is required</mat-error>
        <mat-error *ngIf="supportForm.get('phone')?.hasError('pattern')">Invalid phone format</mat-error>
      </mat-form-field>
    </div>
    <div class="col-span-6">

        <mat-label>Email</mat-label>

      <mat-form-field appearance="outline" class="w-full">
        <input matInput formControlName="email">
        <mat-error *ngIf="supportForm.get('email')?.hasError('required')">Email is required</mat-error>
        <mat-error *ngIf="supportForm.get('email')?.hasError('email')">Invalid email</mat-error>
      </mat-form-field>
    </div>
    <div class="col-span-6">
        <mat-label>Home Phone</mat-label>

      <mat-form-field appearance="outline" class="w-full">
        <input matInput formControlName="homePhone">
        <mat-error *ngIf="supportForm.get('homePhone')?.hasError('pattern')">Invalid phone format</mat-error>
      </mat-form-field>
    </div>
    <div class="col-span-6">
        <mat-label>Site</mat-label>

      <mat-form-field appearance="outline" class="w-full">
        <input matInput formControlName="site">
        <mat-error *ngIf="supportForm.get('site')?.hasError('required')">Site is required</mat-error>
      </mat-form-field>
    </div>
    <div class="col-span-6">
        <mat-label>Site Address</mat-label>

      <mat-form-field appearance="outline" class="w-full">
        <input matInput formControlName="siteAddress">
      </mat-form-field>
    </div>
    <div class="col-span-6">
        <mat-label>Login ID</mat-label>

      <mat-form-field appearance="outline" class="w-full">
        <input matInput formControlName="loginId">
        <mat-error *ngIf="supportForm.get('loginId')?.hasError('required')">Login ID is required</mat-error>
      </mat-form-field>
    </div>
    <div class="col-span-6">
        <mat-label>Password</mat-label>

      <mat-form-field appearance="outline" class="w-full">
        <input matInput type="password" formControlName="password">
        <mat-error *ngIf="supportForm.get('password')?.hasError('required')">Password is required</mat-error>
      </mat-form-field>
    </div>
    <div class="col-span-6">
        <mat-label>License Type</mat-label>

      <mat-form-field appearance="outline" class="w-full">
        <input matInput formControlName="licenseType">
        <mat-error *ngIf="supportForm.get('licenseType')?.hasError('required')">License type is required</mat-error>
      </mat-form-field>
    </div>
    <div class="col-span-6">

      <div formArrayName="permissionGroup">
        <label>Permission Group</label><br>
        <mat-checkbox value="Task User" (change)="onCheckboxChange($event)">Task User</mat-checkbox>
        <mat-checkbox value="Problem User" (change)="onCheckboxChange($event)">Problem User</mat-checkbox>
        <div *ngIf="permissionGroup.invalid && permissionGroup.touched">
          <mat-error>At least one permission must be selected</mat-error>
        </div>
      </div>
    </div>
  </div>
  <div class="w-full flex items-center justify-end mb-2">
    <button mat-raised-button color="primary" type="submit" [disabled]="supportForm.invalid">Add</button>

  </div>

</form>